<script lang="ts">
import { ConfirmPopup } from "./confirm-popup.ts";
export default ConfirmPopup;
</script>

<template>
    <app-modal
        :visible="model.show"
        :visible-cancel-btn="model.type !== 'info' && !!model.cancelBtnText"
        @close-modal="model.closePopup"
        @submit="model.confirm"
        :cancel-button-text="model.cancelBtnText"
        :submit-button-text="model.submitBtnText"
        :submit-button-is-red="model.type === 'warning'"
    >
        <template v-slot:content>
            <img
                src="/img/check-green.svg"
                class="modal__warning"
                v-if="model.type === 'success'"
            />
            <img
                src="/img/complain.svg"
                class="modal__warning"
                v-else-if="model.type !== 'info'"
            />
            <h2 class="modal__title">
                {{ model.message }}
            </h2>
            <h5 v-if="model.submessage">
                {{ model.submessage }}
            </h5>
        </template>
    </app-modal>
</template>

<style scoped></style>
